import React from 'react';
import { CheckBox, CheckBoxState } from 'sos-common/js/components/FormControls/CheckBox';
import { setInnerHtml } from 'sos-common/js/utils/helpers';

export interface IIntygStepTwoSubmitButtonProps {
  conditionsText: string;
  label: string;
  isInEditMode: boolean;
  buttonText: string;
  postLink: string;
  ansokanId: string;
  canSubmit: boolean;
}
export interface IIntygStepTwoSubmitButtonState {
  acceptConditionsChecked: boolean;
}

export class IntygStepTwoSubmitButton extends React.Component<
  IIntygStepTwoSubmitButtonProps,
  IIntygStepTwoSubmitButtonState
> {
  constructor(props: IIntygStepTwoSubmitButtonProps) {
    super(props);

    this.state = {
      acceptConditionsChecked: false,
    };
  }

  onAcceptConditionsChecked = (state: CheckBoxState) => {
    this.setState({ acceptConditionsChecked: state.value });
  };

  private get _isButtonActive(): boolean {
    return this.state.acceptConditionsChecked && this.props.canSubmit;
  }

  public render() {
    const { conditionsText, isInEditMode, label, buttonText, postLink, ansokanId } = this.props;
    return (
      <>
        <form action={postLink} method="post">
          <input type="hidden" name="ansokanId" value={ansokanId} />
          <div dangerouslySetInnerHTML={setInnerHtml(conditionsText)}></div>
          <CheckBox
            stringValue="Jag bekräftar"
            onChangeCallback={this.onAcceptConditionsChecked}
            label={label}
            disabled={isInEditMode}
            fieldName="acceptConditionsStepTwo"
          />
          <div className="form-submit">
            {this._isButtonActive && (
              <button className="button relative" type="submit">
                {buttonText}
              </button>
            )}
            {!this._isButtonActive && (
              <span className="button button--disabled" aria-disabled="true">
                {buttonText}
              </span>
            )}
          </div>
        </form>
      </>
    );
  }
}
